import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonPinCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person_pin_circle"}/>
}
